// src/pages/PrivacyPolicy.js
// Page Politique de confidentialité - bilingue FR/EN via i18n

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../hooks/useTheme';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { theme } = useTheme();

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: theme.bg },
    header: {
      display: 'flex', alignItems: 'center', gap: '12px', padding: '16px',
      position: 'sticky', top: 0, backgroundColor: theme.bg, zIndex: 50, borderBottom: `1px solid ${theme.borderSoft}`,
    },
    backButton: { background: 'none', border: 'none', color: theme.textPrimary, fontSize: '20px', cursor: 'pointer' },
    title: { fontSize: '18px', fontWeight: '700', color: theme.textPrimary },
    content: { padding: '20px 16px 60px', display: 'flex', flexDirection: 'column', gap: '20px' },
    lastUpdated: { fontSize: '13px', color: theme.textSecondary, fontStyle: 'italic' },
    intro: { fontSize: '14px', color: theme.textPrimary, lineHeight: '1.6' },
    sectionTitle: { fontSize: '16px', fontWeight: '700', color: theme.textPrimary, marginTop: '8px' },
    sectionText: { fontSize: '14px', color: theme.textSecondary, lineHeight: '1.6' },
    bulletList: { display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '4px' },
    bulletItem: { fontSize: '14px', color: theme.textSecondary, lineHeight: '1.6' },
    contactBox: {
      marginTop: '10px', padding: '16px', backgroundColor: theme.bgCard, borderRadius: '12px',
      border: `1px solid ${theme.border}`,
    },
    contactEmail: { fontSize: '14px', fontWeight: '600', color: theme.gold, marginTop: '6px' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>{t('privacy.title')} | Fynho</title>
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>←</button>
        <div style={styles.title}>{t('privacy.title')}</div>
      </div>

      <div style={styles.content}>
        <div style={styles.lastUpdated}>{t('privacy.lastUpdated')}</div>
        <p style={styles.intro}>{t('privacy.intro')}</p>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section1Title')}</div>
          <div style={styles.bulletList}>
            <div style={styles.bulletItem}>• {t('privacy.section1Location')}</div>
            <div style={styles.bulletItem}>• {t('privacy.section1Account')}</div>
            <div style={styles.bulletItem}>• {t('privacy.section1Content')}</div>
            <div style={styles.bulletItem}>• {t('privacy.section1Usage')}</div>
          </div>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section2Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section2Text')}</p>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section3Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section3Text')}</p>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section4Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section4Text')}</p>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section5Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section5Text')}</p>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section6Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section6Text')}</p>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section7Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section7Text')}</p>
        </div>

        <div>
          <div style={styles.sectionTitle}>{t('privacy.section8Title')}</div>
          <p style={styles.sectionText}>{t('privacy.section8Text')}</p>
        </div>

        <div style={styles.contactBox}>
          <div style={styles.sectionTitle}>{t('privacy.contactTitle')}</div>
          <p style={styles.sectionText}>{t('privacy.contactText')}</p>
          <div style={styles.contactEmail}>support@fynho.com</div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;